import { on } from "svelte/events";
import {
  SHEET_ACTION_BACK_BUTTON,
  SHEET_ACTION_BACK_DROP,
  SHEET_ACTION_CLOSE_BUTTON,
  SHEET_ACTION_ESCAPE_KEY,
} from "../event/event.action.defs";
import { sheetClose, sheetGoBack } from "../apis/methods.js";
import { stack } from "../stack/stack.global.svelte";
import { interactionScope } from "./utils";
import { canUseHtmlDialogElement } from "../../../../common/utils/canUseHtmlDialogElement";
import type { OcSheetV1VisibilityState } from "../instance/visibility.svelte";

const log = /*           */ interactionScope.scope("close-handler");

/**
 *
 *
 *
 *
 */
export const onBackdropClick = (
  visibilityState: OcSheetV1VisibilityState,
): ((ev: MouseEvent) => void) => {
  return (ev) => {
    if (ev.detail === 0) return; /*                                                       */
    if (visibilityState.isShown === false) return; /*                                          */

    if (canUseHtmlDialogElement) {
      /*                                         */
      if (ev.target instanceof HTMLElement && ev.target.tagName === "DIALOG") {
        const rect = ev.target.getBoundingClientRect();
        if (
          rect.left > ev.clientX ||
          rect.right < ev.clientX ||
          rect.top > ev.clientY ||
          rect.bottom < ev.clientY
        ) {
          sheetClose({ action: SHEET_ACTION_BACK_DROP });
        }
      }
    } else if (ev.currentTarget === ev.composedPath()[0]) {
      /*                                                                    */
      sheetClose({ action: SHEET_ACTION_BACK_DROP });
    }
  };
};

/**
 *
 *
 *
 *
 */
export const onCloseButtonClick = (): void => {
  sheetClose({ action: SHEET_ACTION_CLOSE_BUTTON });
};

export const onBackButtonClick = (): void => {
  sheetGoBack({ action: SHEET_ACTION_BACK_BUTTON });
};

/**
 *
 *
 *
 *
 *
 *
 */
const sheetHandleESCKey = (ev: KeyboardEvent): void => {
  if (ev.code === "Escape") {
    log.info("ESC key pressed, close presentation stack");
    ev.preventDefault(); /*                                         */
    sheetClose({ action: SHEET_ACTION_ESCAPE_KEY });
  }
};

/**
 *
 *
 */
export const useSheetCloseHandler = (): void => {
  $effect.root(() => {
    $effect(() => {
      if (stack.current) {
        log.info("Sheet is open, register ESC key listener");
        /*                                                                             */
        return on(document, "keydown", sheetHandleESCKey);
      }
    });
  });
};
